<template>
  <div class="pa-3 ma-3">
    <v-alert-dialog ref="alert"></v-alert-dialog>

    <v-dialog
      max-width="80%"
      v-model="dialogAddEdit"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title>
          {{ editedItem.id_programacion_compra_orden === null ? "Crear" : "Editar" }} Orden de Programación de Pago
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6" class="my-3">
              <v-autocomplete-gasto-subtipo
                v-model="editedItem.id_gasto_subtipo"
                :items="gastoSubtipos"
                :loading="loadingGastoSubtipos || loadingFiscalReglas"
                :label="`Tipo de Gasto *`"
                @input="getFiscalReglas"
                :disabled="loadingFiscalReglas"
              >
              </v-autocomplete-gasto-subtipo>
            </v-col>

            <v-col cols="12" md="2" class="my-3">
              <v-select
                v-model="editedItem.id_moneda"
                :items="monedas"
                :loading="loadingMonedas"
                item-value="id_moneda"
                item-text="clave"
                label="Moneda *"
                outlined
                dense
                hide-details="auto"
                @change="setIdReglaFiscal"
              >
                <template v-slot:selection="{ item }">
                  {{ item.clave }}
                </template>
                <template v-slot:item="{ item }">
                  <div>
                    {{ item.clave }} - {{ item.nombre }}
                  </div>
                </template>
              </v-select>
              <template v-if="getMonedaFechaCambio(editedItem.id_moneda) != null">
                1 {{getMonedaClave(editedItem.id_moneda)}} = {{getMonedaCambio(editedItem.id_moneda)}} MXN - {{getMonedaFechaCambio(editedItem.id_moneda)}}
              </template>
            </v-col>

            <v-col cols="12" md="4" class="my-3">
              <v-text-field
                v-model.number="editedItem.monto"
                label="Monto Total (sin impuestos) *"
                outlined
                dense
                type="number"
                step="0.01"
                min="0"
                prefix="$"
                hide-details="auto"
                @input="recalcularFacturas"
                :disabled="editedItem.id_moneda == null"
              ></v-text-field>
            </v-col>

            

            <template v-if="mostrarCampo(1)">
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="editedItem.no_serie"
                  outlined
                  :label="`No. de Serie${esRequerido(1) ? ' *' : ''}`"
                  dense
                  hide-details
                  clearable
                >
                </v-text-field>
              </v-col>
            </template>

            <template v-if="mostrarCampo(2)">
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="editedItem.marca"
                  outlined
                  :label="`Marca${esRequerido(2) ? ' *' : ''}`"
                  dense
                  hide-details
                  clearable
                >
                </v-text-field>
              </v-col>
            </template>

            <template v-if="mostrarCampo(3)">
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="editedItem.modelo"
                  outlined
                  :label="`Modelo${esRequerido(3) ? ' *' : ''}`"
                  dense
                  hide-details
                  clearable
                >
                </v-text-field>
              </v-col>
            </template>

            <template v-if="mostrarCampo(4)">
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="editedItem.no_inventario_ubga"
                  outlined
                  :label="`No. Inventario UBGA${esRequerido(4) ? ' *' : ''}`"
                  dense
                  hide-details
                  clearable
                >
                </v-text-field>
              </v-col>
            </template>

            <template v-if="mostrarCampo(5)">
              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="editedItem.id_proyecto"
                  :items="proyectos"
                  outlined
                  :label="`Proyecto${esRequerido(5) ? ' *' : ''}`"
                  :item-text="codigoNombre"
                  item-value="id_proyecto"
                  :loading="loadingProyectos"
                  :disabled="loadingProyectos"
                  dense
                  hide-details
                  clearable
                >
              </v-autocomplete>
              </v-col>
            </template>

            <template v-if="mostrarCampo(6)">
              <v-col cols="12" md="4">
                <v-autocomplete-empleado
                  v-model="editedItem.ids_empleados"
                  :items="empleados"
                  :loading="loadingEmpleados"
                  :label="`Empleado(s)${esRequerido(6) ? ' *' : ''}`"
                >
                </v-autocomplete-empleado>
              </v-col>
            </template>

            <v-col cols="12">
              <v-autocomplete-proveedor
                v-model="editedItem.id_proveedor"
                :items="proveedores"
                :loading="loadingProveedores || loadingFiscalReglas"
                :disabled="loadingFiscalReglas"
                @input="getFiscalReglas"
              />
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="editedItem.descripcion"
                label="Descripción"
                outlined
                dense
                rows="1"
                auto-grow
                hide-details="auto"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-file-input-plus
                v-model="editedItem.archivo_cotizacion"
                url-base="/api/Pagos/DescargarProgramacionCompraOrdenDocumento"
                dense
                accept=".pdf"
                :max-size="5242880"
                hide-details
                outlined
                label="Cotización/Presupuesto"
              ></v-file-input-plus>
            </v-col>
            <v-col cols="auto">
              <v-checkbox
                v-model="editedItem.usar_iva_frontera"
                label="Usar IVA del 8%"
                dense
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <!-- Sin selección previa -->
              <v-alert
                v-if="fiscalReglas == null"
                type="info"
                text
                dense
                class="mb-0"
              >
                Selecciona <strong>Tipo de Gasto</strong> y <strong>Proveedor</strong> para cargar las reglas fiscales.
              </v-alert>

              <!-- No hay reglas -->
              <v-alert
                v-else-if="fiscalReglas.length === 0"
                type="warning"
                text
                dense
                class="mb-0"
              >
                No hay reglas fiscales para este <strong>Tipo de Proveedor</strong> y <strong>Tipo de Gasto</strong>.
              </v-alert>

              <!-- Sí hay reglas -->
              <v-autocomplete-fiscal-regla
                v-else
                v-model="editedItem.id_fiscal_regla"
                :items="fiscalReglasFiltradas"
                :loading="loadingFiscalReglas"
                :ivaFrontera="editedItem.usar_iva_frontera"
              />
            </v-col>



            <v-col cols="12" md="6">
              <v-text-field
                v-model.number="editedItem.numero_facturas"
                label="Número de Facturas Esperadas *"
                outlined
                dense
                type="number"
                min="1"
                max="99"
                hide-details="auto"
                @input="onNumeroFacturasChange"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" v-if="editedItem.numero_facturas > 1">
              <v-select
                v-model="editedItem.id_intervalo"
                label="Intervalo de Facturación *"
                outlined
                dense
                :items="intervalosFacturacion"
                item-value="id_intervalo"
                item-text="nombre"
                hide-details="auto"
                @change="recalcularFechas"
              ></v-select>
            </v-col>

            <v-col cols="12" md="6" v-if="editedItem.numero_facturas > 1">
              <v-menu
                ref="menuFechaInicio"
                v-model="menuFechaInicio"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="editedItem.fecha_inicio"
                    label="Fecha de Inicio *"
                    outlined
                    dense
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    hide-details="auto"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="editedItem.fecha_inicio"
                  @input="menuFechaInicio = false; recalcularFechas()"
                  locale="es"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <!-- Tabla de facturas programadas -->
          <v-row v-if="editedItem.numero_facturas > 0" class="mt-4">
            <v-col cols="12">
              <v-divider></v-divider>
              <h3 class="mt-3 mb-3">Programación de Facturas</h3>
              <v-alert
                type="info"
                dense
                outlined
                class="mb-3"
              >
                La suma de los montos debe ser igual al monto total: ${{ formatMoney(editedItem.monto) }}
                <br>
                <strong>Suma actual: ${{ formatMoney(sumaFacturas) }}</strong>
                <span v-if="Math.abs(sumaFacturas - editedItem.monto) > 0.01" class="red--text">
                  (Diferencia: ${{ formatMoney(Math.abs(sumaFacturas - editedItem.monto)) }})
                </span>
              </v-alert>

              <v-data-table
                :headers="headersFacturas"
                :items="editedItem.facturas"
                :items-per-page="-1"
                hide-default-footer
                dense
              >
                <template v-slot:[`item.numero`]="{ index }">
                  {{ index + 1 }}
                </template>

                <template v-slot:[`item.fecha`]="{ item, index }">
                  <v-menu
                    :ref="`menuFactura${index}`"
                    v-model="item.menuFecha"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="item.fecha"
                        dense
                        outlined
                        hide-details
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        class="ma-2"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="item.fecha"
                      @input="item.menuFecha = false"
                      locale="es"
                    ></v-date-picker>
                  </v-menu>
                </template>

                <template v-slot:[`item.monto`]="{ item }">
                  <v-text-field
                    v-model.number="item.monto"
                    dense
                    outlined
                    hide-details
                    type="number"
                    step="0.01"
                    min="0"
                    :prefix="getMonedaSimbolo(editedItem.id_moneda)"
                    :suffix="getMonedaClave(editedItem.id_moneda)"
                    @input="validarSumaFacturas"
                    class="ma-2"
                  ></v-text-field>
                </template>

                <template v-slot:[`item.iva`]="{ item }">
                  {{ getMonedaSimbolo(editedItem.id_moneda) }} {{ formatMoney(getIva(item.monto)) }} {{ getMonedaClave(editedItem.id_moneda) }}
                </template>

                <template v-slot:[`item.isr`]="{ item }">
                  {{ getMonedaSimbolo(editedItem.id_moneda) }} {{ formatMoney(getIsr(item.monto)) }} {{ getMonedaClave(editedItem.id_moneda) }}
                </template>

                <template v-slot:[`item.iva_retencion`]="{ item }">
                  {{ getMonedaSimbolo(editedItem.id_moneda) }} {{ formatMoney(getIvaRetencion(item.monto)) }} {{ getMonedaClave(editedItem.id_moneda) }}
                </template>

                <template v-slot:[`item.total`]="{ item }">
                  {{ getMonedaSimbolo(editedItem.id_moneda) }} {{ formatMoney(getTotal(item.monto)) }} {{ getMonedaClave(editedItem.id_moneda) }}
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="green" text @click="closeDialogAddEdit">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="saveDialogAddEdit" :loading="loadingSave">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogDelete"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-title>
          Cancelar Orden de Programación de Pago
        </v-card-title>

        <v-card-text class="pt-4">
          <v-alert
            color="red"
            outlined
            class="mb-4"
          >
            <v-row align="center">
              <v-col cols="auto">
                <v-icon size="48" color="red">
                  mdi-alert
                </v-icon>
              </v-col>

              <v-col class="grow">
                <div class="text-h6 error--text text--darken-2">
                  Confirmación de cancelación
                </div>

                <div class="mt-2 black--text">
                  ¿Está seguro que desea cancelar esta Orden de Programación de Pago?
                </div>

                <div class="mt-2 font-weight-bold error--text">
                  Esta acción no se puede deshacer
                </div>
              </v-col>
            </v-row>
          </v-alert>

          <v-simple-table>
            <tbody>
              <tr>
                <td class="font-weight-bold" width="40%"># Orden de Programación de Pago:</td>
                <td>{{ editedItem.clave }}</td>
              </tr>

              <tr>
                <td class="font-weight-bold">Concepto:</td>
                <td>
                  <strong>{{ editedItem.nombre_gasto_tipo }}</strong>
                  - {{ editedItem.nombre_gasto_subtipo }}
                </td>
              </tr>

              <tr>
                <td class="font-weight-bold">Proveedor:</td>
                <td>{{ editedItem.nombre_proveedor || '—' }}</td>
              </tr>

              <tr>
                <td class="font-weight-bold">Descripción:</td>
                <td>{{ editedItem.descripcion || '—' }}</td>
              </tr>

              <tr>
                <td class="font-weight-bold">Monto Total:</td>
                <td>
                  <span class="text-subtitle-1 primary--text">
                    ${{ formatMoney(editedItem.monto) }} {{ editedItem.moneda_clave || '' }}
                  </span>
                </td>
              </tr>
            </tbody>
          </v-simple-table>

          <v-divider class="my-4"></v-divider>

          <div class="text-caption">
            Al confirmar, la orden quedará <strong>Cancelada</strong> y se notificará al Proveedor.
          </div>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="green"
            text
            @click="closeDialogDelete"
            :disabled="loadingDelete"
          >
            Cerrar
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn
            color="red"
            text
            @click="saveDialogDelete"
            :loading="loadingDelete"
          >
            Confirmar cancelación
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <detalles ref="detalles"></detalles>

    <v-dialog
      max-width="600px"
      v-model="dialogAutorizar"
      persistent
    >
      <v-card>
        <v-card-title>
          Autorizar Orden de Programación de Pago
        </v-card-title>
        <v-card-text class="pt-4">
          <v-alert
            v-if="requiereAutorizacionDireccionGeneral(autorizarItem)"
            color="red"
            outlined
            class="mb-4"
          >
            <v-row align="center">
              <v-col cols="auto">
                <v-icon size="48" color="red">
                  mdi-alert
                </v-icon>
              </v-col>
              <v-col class="grow">
                <div class="text-h6 warning--text text--darken-3">
                  Autorización de Dirección General Requerida
                </div>
                <div class="mt-3 black--text">
                  Esta Orden de Programación de Pago tiene un monto de
                  <strong class="primary--text">${{ formatMoney(getTotalGlobal(autorizarItem)) }} {{ autorizarItem.moneda_clave }}</strong>,
                  el cual excede el límite de autorización estándar de
                  <strong class="error--text">${{ formatMoney(getLimiteAutorizacion(autorizarItem.id_moneda)) }} {{ autorizarItem.moneda_clave }}</strong>.
                </div>
                <div class="mt-3 font-weight-bold error--text">
                  Esta operación debe ser autorizada por Dirección General.
                </div>
              </v-col>
            </v-row>
          </v-alert>

          <v-alert
            v-else
            color="orange"
            outlined
            class="mb-4"
          >
            <v-row align="center">
              <v-col cols="auto">
                <v-icon size="48" color="orange">
                  mdi-alert
                </v-icon>
              </v-col>
              <v-col>
                <div class="text-body-1">
                  ¿Está seguro que desea autorizar esta Orden de Programación de Pago?
                </div>
              </v-col>
            </v-row>
          </v-alert>

          <v-simple-table>
            <tbody>
              <tr>
                <td class="font-weight-bold" width="40%"># Orden de Programación de Pago:</td>
                <td>
                  {{ autorizarItem.clave }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Concepto:</td>
                <td><strong>{{ autorizarItem.nombre_gasto_tipo }}</strong> - {{ autorizarItem.nombre_gasto_subtipo }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Descripción:</td>
                <td>{{ autorizarItem.descripcion }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Total Factura:</td>
                <td>
                  <span class="text-subtitle-1 primary--text">${{ formatMoney(autorizarItem.total_factura) }} {{ autorizarItem.moneda_clave || '' }}</span>
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Total Pagado:</td>
                <td>
                  <span class="text-subtitle-1 primary--text">${{ formatMoney(autorizarItem.total_pagado) }} {{ autorizarItem.moneda_clave || '' }}</span>
                </td>
              </tr>
            </tbody>
          </v-simple-table>

          <v-divider class="my-4"></v-divider>

          <div class="text-caption" v-if="!requiereAutorizacionDireccionGeneral(autorizarItem)">
            Al confirmar esta acción, la Orden de Programación de Pago quedará <strong>Autorizada</strong> y se enviará una notificación al Proveedor.
          </div>
        </v-card-text>
        <v-card-actions>
          <template v-if="!requiereAutorizacionDireccionGeneral(autorizarItem)">
            <v-btn color="green" text @click="closeDialogAutorizar">Cancelar</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              text
              @click="saveDialogAutorizar"
              :loading="loadingAutorizar"
            >
              Confirmar Autorización
            </v-btn>
          </template>
          <template v-else>
            <v-spacer></v-spacer>
            <v-btn color="green" text @click="closeDialogAutorizar">Cancelar</v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12">
        <v-card outlined class="pa-4">
          <div class="caption mb-1 pl-3">Estado de las Ordenes de Programación de Pago</div>
          <v-row class="pa-0 ma-0 five-columns">
            <v-col class="my-0 py-0 five-col-item">
              <div class="kpi-line">
                <span class="kpi-figure">{{ pct(stats.pendiente_per) }}</span>
                <span class="kpi-pill kpi-pill--warning">
                  {{ nf(stats.pendiente_num) }} /
                  {{ nf(stats.total) }}
                </span>
              </div>
              <v-progress-linear
                :value="stats.pendiente_per * 100"
                height="8"
                color="orange darken-2"
                class="mt-2"
              />
              <div class="caption mb-1">Pendiente Autorización</div>
            </v-col>

            <v-col class="my-0 py-0 five-col-item">
              <div class="kpi-line">
                <span class="kpi-figure">{{ pct(stats.autorizada_per) }}</span>
                <span class="kpi-pill kpi-pill--success">
                  {{ nf(stats.autorizada_num) }} /
                  {{ nf(stats.total) }}
                </span>
              </div>
              <v-progress-linear
                :value="stats.autorizada_per * 100"
                height="8"
                color="green darken-2"
                class="mt-2"
              />
              <div class="caption mb-1">Autorizada</div>
            </v-col>

            <v-col class="my-0 py-0 five-col-item">
              <div class="kpi-line">
                <span class="kpi-figure">{{ pct(stats.facturada_parcial_per) }}</span>
                <span class="kpi-pill kpi-pill--info">
                  {{ nf(stats.facturada_parcial_num) }} /
                  {{ nf(stats.total) }}
                </span>
              </div>
              <v-progress-linear
                :value="stats.facturada_parcial_per * 100"
                height="8"
                color="blue darken-2"
                class="mt-2"
              />
              <div class="caption mb-1">Facturada Parcial</div>
            </v-col>

            <v-col class="my-0 py-0 five-col-item">
              <div class="kpi-line">
                <span class="kpi-figure">{{ pct(stats.facturada_total_per) }}</span>
                <span class="kpi-pill kpi-pill--primary">
                  {{ nf(stats.facturada_total_num) }} /
                  {{ nf(stats.total) }}
                </span>
              </div>
              <v-progress-linear
                :value="stats.facturada_total_per * 100"
                height="8"
                color="primary"
                class="mt-2"
              />
              <div class="caption mb-1">Facturada Total</div>
            </v-col>

            <v-col class="my-0 py-0 five-col-item">
              <div class="kpi-line">
                <span class="kpi-figure">{{ pct(stats.cancelada_per) }}</span>
                <span class="kpi-pill kpi-pill--error">
                  {{ nf(stats.cancelada_num) }} /
                  {{ nf(stats.total) }}
                </span>
              </div>
              <v-progress-linear
                :value="stats.cancelada_per * 100"
                height="8"
                color="red darken-2"
                class="mt-2"
              />
              <div class="caption mb-1">Cancelada</div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-btn
          color="primary"
          @click="openDialogAddEdit(null)"
        >
          Nueva Orden de Programación de Pago
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3">
        <v-autocomplete
          v-model="search.programacion_pago_orden_estado"
          dense
          hide-details
          outlined
          label="Estado de la Orden de Programación de Pago"
          item-value="id_estado"
          item-text="nombre"
          :items="estadosOrden"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="3">
        <v-autocomplete-proveedor
          v-model="search.id_proveedor"
          :items="proveedores"
          :loading="loadingProveedores"
        />
      </v-col>

      <v-col cols="3">
        <v-text-field
          v-model="search.num_programacion_pago_orden"
          dense
          hide-details
          outlined
          label="# Orden de Programación de Pago"
          clearable
        >
        </v-text-field>
      </v-col>

      <v-col cols="3">
        <v-btn
          color="primary"
          text
          outlined
          block
          @click="getItems"
        >
          <v-icon> mdi-magnify </v-icon>
          Buscar
        </v-btn>
      </v-col>
    </v-row>
    
    <v-row>
      <v-col cols="12">
        <v-data-table
          :items="items"
          :headers="headers"
          :loading="loading"
        >
          <template v-slot:[`item.numero_orden`]="{ item }">
            {{ item.clave }}
          </template>

          <template v-slot:[`item.concepto`]="{ item }">
            <strong>{{ item.nombre_gasto_tipo }}</strong> - {{ item.nombre_gasto_subtipo }}
          </template>

          <template v-slot:[`item.proveedor_nombre`]="{ item }">
            <div class="d-flex align-center">
              <div>
                <div class="text-caption">{{ item.nombre_proveedor }}</div>
                <div class="text-caption">{{ item.codigo_proveedor }} - {{item.tipo_proveedor}}</div>
              </div>
            </div>
          </template>

          <template v-slot:[`item.id_estado`]="{ item }">
            <v-tooltip bottom color="black">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  :color="getEstadoConfig(item.id_estado).color"
                >
                  {{ getEstadoConfig(item.id_estado).icon }}
                </v-icon>
              </template>
              <span>{{ getEstadoConfig(item.id_estado).tooltip }}</span>
            </v-tooltip>
          </template>

          <template v-slot:[`item.monto`]="{ item }">
            <strong>F:</strong> {{ getMonedaSimbolo(item.id_moneda) }} {{ formatMoney(item.total_factura) }} {{ getMonedaClave(item.id_moneda) }}
            <br>
            <strong>P:</strong> {{ getMonedaSimbolo(item.id_moneda) }} {{ formatMoney(item.total_pagado) }} {{ getMonedaClave(item.id_moneda) }}
          </template>

          <template v-slot:[`item.numero_facturas`]="{ item }">
            <div class="d-flex flex-column align-center" style="gap: 4px;">
              <!-- Chip: facturas cargadas -->
              <v-tooltip bottom color="black">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    x-small
                    :color="getFacturasCargadasColor(item.facturas_cargadas, item.numero_facturas)"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon left x-small>mdi-file-upload</v-icon>
                    {{ item.facturas_cargadas || 0 }} de {{ item.numero_facturas }}
                  </v-chip>
                </template>
                <span>
                  Facturas cargadas: {{ item.facturas_cargadas || 0 }} de {{ item.numero_facturas }}
                </span>
              </v-tooltip>

              <!-- Chip: facturas autorizadas -->
              <v-tooltip bottom color="black">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    x-small
                    :color="getFacturasAutorizadasColor(item.facturas_autorizadas, item.numero_facturas)"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon left x-small>mdi-check-decagram</v-icon>
                    {{ item.facturas_autorizadas || 0 }} de {{ item.numero_facturas }}
                  </v-chip>
                </template>
                <span>
                  Facturas autorizadas: {{ item.facturas_autorizadas || 0 }} de {{ item.numero_facturas }}
                </span>
              </v-tooltip>
            </div>
          </template>

          <template v-slot:[`item.facturas_pagadas`]="{ item }">
            <div class="d-flex justify-center">
              <v-chip
                small
                :color="getFacturasPagadasColor(item.facturas_pagadas, item.facturas_autorizadas)"
                dark
              >
                <v-icon left small>mdi-cash-check</v-icon>
                {{ item.facturas_pagadas || 0 }} de {{ item.facturas_autorizadas || 0 }}
              </v-chip>
            </div>
          </template>

          <template v-slot:[`item.id_intervalo`]="{ item }">
            {{ getIntervaloNombre(item.id_intervalo) }}
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom color="black"
              v-if="(item.id_estado === ESTADOS.PENDIENTE_AUTORIZACION && (mostrarVista(7) || mostrarVista(15)))"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="openDialogAutorizar(item)"
                >
                  mdi-progress-check
                </v-icon>
              </template>
              <span>Autorizar Orden de Programación de Pago</span>
            </v-tooltip>

            <v-tooltip bottom color="black">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="openDialogView(item)"
                >
                  mdi-eye
                </v-icon>
              </template>
              <span>Ver detalles</span>
            </v-tooltip>

            <v-tooltip
              bottom
              color="black"
              v-if="item.id_estado != ESTADOS.CANCELADA && item.id_estado != ESTADOS.FACTURADA_TOTAL && ((item.id_estado == ESTADOS.PENDIENTE_AUTORIZACION && (mostrarVista(14) || mostrarVista(7))) || mostrarVista(15))"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="openDialogAddEdit(item)"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>Editar Orden de Programación de Pago</span>
            </v-tooltip>

            <v-tooltip
              bottom
              color="black"
              v-if="item.id_estado != ESTADOS.CANCELADA && item.id_estado != ESTADOS.FACTURADA_TOTAL && (item.id_estado == ESTADOS.PENDIENTE_AUTORIZACION || mostrarVista(15))">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="openDialogDelete(item)"
                >
                  mdi-close
                </v-icon>
              </template>
              <span>Cancelar Orden de Programación de Pago</span>
            </v-tooltip>

          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from "vuex";
import VAlertDialog from '@/components/VAlertDialog.vue';
import Detalles from './ProgramacionPagoOrden/Detalles.vue'
import VAutocompleteProveedor from './VAutocompleteProveedor.vue';
import VAutocompleteGastoSubtipo from './VAutocompleteGastoSubtipo.vue';
import VAutocompleteEmpleado from './VAutocompleteEmpleado.vue';
import VAutocompleteFiscalRegla from './VAutocompleteFiscalRegla.vue';
import VFileInputPlus from '@/components/VFileInputPlus.vue';

export default {
  components: {
    VAlertDialog,
    Detalles,
    VAutocompleteProveedor,
    VAutocompleteGastoSubtipo,
    VAutocompleteEmpleado,
    VAutocompleteFiscalRegla,
    VFileInputPlus
  },
  data: () => ({
    // ========== CONSTANTES DE ESTADOS ==========
    ESTADOS: {
      PENDIENTE_AUTORIZACION: 1,
      AUTORIZADA: 2,
      FACTURADA_PARCIAL: 3,
      FACTURADA_TOTAL: 4,
      CANCELADA: 5
    },

    // ========== CONSTANTES DE INTERVALOS ==========
    INTERVALOS: {
      BAJO_DEMANDA: 1,
      SEMANAL: 2,
      QUINCENAL: 3,
      MENSUAL: 4,
      BIMESTRAL: 5,
      TRIMESTRAL: 6,
      CUATRIMESTRAL: 7,
      SEMESTRAL: 8,
      ANUAL: 9
    },

    dialogAddEdit: false,
    loading: false,
    items: [],
    headers: [
      {
        text: "Estado",
        value: "id_estado",
        align: "center",
        width: "4%"
      },
      {
        text: "# Orden de Programación de Pago",
        value: "numero_orden",
        align: "center",
        width: "14%"
      },
      {
        text: "Concepto",
        value: "concepto",
        align: "left",
        width: "15%"
      },
      {
        text: "Proveedor",
        value: "proveedor_nombre",
        align: "left",
        width: "12%"
      },
      {
        text: "Monto Total",
        value: "monto",
        align: "center",
        width: "10%"
      },
      {
        text: "Facturas",
        value: "numero_facturas",
        align: "center",
        width: "10%"
      },
      /*
      {
        text: "Pagos",
        value: "facturas_pagadas",
        align: "center",
        width: "10%"
      },
      */
      {
        text: "Intervalo",
        value: "id_intervalo",
        align: "center",
        width: "10%"
      },
      {
        text: "Acciones",
        value: "actions",
        align: "center",
        width: "10%"
      }
    ],
    headersFacturas: [
      {
        text: "N°",
        value: "numero",
        align: "center",
        width: "5%",
        sortable: false
      },
      {
        text: "Fecha habilitada para recepción",
        value: "fecha",
        align: "center",
        width: "15%",
        sortable: false
      },
      {
        text: "Monto",
        value: "monto",
        align: "center",
        width: "16%",
        sortable: false
      },
      {
        text: "IVA",
        value: "iva",
        align: "end",
        width: "16%",
        sortable: false
      },
      {
        text: "ISR",
        value: "isr",
        align: "end",
        width: "16%",
        sortable: false
      },
      {
        text: "Retención IVA",
        value: "iva_retencion",
        align: "end",
        width: "16%",
        sortable: false
      },
      {
        text: "Total",
        value: "total",
        align: "end",
        width: "16%",
        sortable: false
      },
    ],
    editedItem: {
      id_programacion_compra_orden: null,
      id_gasto_subtipo: null,
      numero_orden: null,
      descripcion: "",
      id_moneda: null,
      monto: 0,
      no_serie: null,
      marca: null,
      modelo: null,
      no_inventario_ubga: null,
      id_proyecto: null,
      ids_empleados: null,
      id_proveedor: null,
      archivo_cotizacion: null,
      id_fiscal_regla: null,
      usar_iva_frontera: false,
      numero_facturas: 1,
      id_intervalo: 1,
      fecha_inicio: new Date().toISOString().substr(0, 10),
      facturas: []
    },
    defaultEditedItem: {
      id_programacion_compra_orden: null,
      id_gasto_subtipo: null,
      numero_orden: null,
      descripcion: "",
      id_moneda: null,
      monto: 0,
      no_serie: null,
      marca: null,
      modelo: null,
      no_inventario_ubga: null,
      id_proyecto: null,
      ids_empleados: null,
      id_proveedor: null,
      archivo_cotizacion: null,
      id_fiscal_regla: null,
      usar_iva_frontera: false,
      numero_facturas: 1,
      id_intervalo: 1,
      fecha_inicio: new Date().toISOString().substr(0, 10),
      facturas: []
    },
    intervalosFacturacion: [
      { id_intervalo: 1, nombre: "Bajo demanda", dias: 1 },
      { id_intervalo: 2, nombre: "Semanal", dias: 7 },
      { id_intervalo: 3, nombre: "Quincenal", dias: 15 },
      { id_intervalo: 4, nombre: "Mensual", meses: 1 },
      { id_intervalo: 5, nombre: "Bimestral", meses: 2 },
      { id_intervalo: 6, nombre: "Trimestral", meses: 3 },
      { id_intervalo: 7, nombre: "Cuatrimestral", meses: 4 },
      { id_intervalo: 8, nombre: "Semestral", meses: 6 },
      { id_intervalo: 9, nombre: "Anual", años: 1 }
    ],
    estadosOrden: [
      {
        id_estado: 1,
        nombre: 'Pendiente de Autorización',
        color: 'orange',
        icon: 'mdi-clock-alert',
        tooltip: 'La orden está pendiente de ser autorizada'
      },
      {
        id_estado: 2,
        nombre: 'Autorizada',
        color: 'green',
        icon: 'mdi-check-circle',
        tooltip: 'La orden ha sido autorizada y está lista para recibir facturas del proveedor'
      },
      {
        id_estado: 3,
        nombre: 'Facturada Parcialmente',
        color: 'blue',
        icon: 'mdi-file-document-multiple',
        tooltip: 'Se han recibido algunas facturas por parte del proveedor'
      },
      {
        id_estado: 4,
        nombre: 'Facturada Total',
        color: 'success',
        icon: 'mdi-check-all',
        tooltip: 'Todas las facturas han sido recibidas'
      },
      {
        id_estado: 5,
        nombre: 'Cancelada',
        color: 'red',
        icon: 'mdi-close-circle',
        tooltip: 'La orden ha sido cancelada'
      },
      {
        id_estado: 6,
        nombre: 'Facturas con errores',
        color: 'orange',
        icon: 'mdi-alert',
        tooltip: 'Se detectaron errores en una o más facturas asociadas a esta orden. Revisa el detalle y corrige para continuar.'
      }
    ],

    loadingSave: false,
    dialogDelete: false,
    loadingDelete: false,
    dialogAutorizar: false,
    loadingAutorizar: false,
    autorizarItem: {
      id_programacion_compra_orden: null,
      numero_orden: null,
      nombre: "",
      monto: 0,
      id_moneda: null,
      moneda_clave: null,
      id_estado: null
    },
    menuFechaInicio: false,
    // Proveedores
    proveedores: [],
    loadingProveedores: false,
    // Monedas
    monedas: [],
    loadingMonedas: false,

    //Proyectos
    proyectos: [],
    loadingProyectos: false,

    //Empleados
    empleados: [],
    loadingEmpleados: false,

    stats: {
      total: 0,
      pendiente_num: 0,
      pendiente_per: 0,
      autorizada_num: 0,
      autorizada_per: 0,
      facturada_parcial_num: 0,
      facturada_parcial_per: 0,
      facturada_total_num: 0,
      facturada_total_per: 0,
      cancelada_num: 0,
      cancelada_per: 0,
    },

    search: {
      programacion_pago_orden_estado: null,
      id_proveedor: null,
      num_programacion_pago_orden: null
    },

    loadingGastoSubtipos: false,
    gastoSubtipos: [],

    loadingFiscalReglas: false,
    fiscalReglas: null,
  }),
  computed: {
    ...mapState(['ids_vistas']),
    sumaFacturas() {
      return this.editedItem.facturas.reduce((sum, factura) => {
        return sum + (parseFloat(factura.monto) || 0);
      }, 0);
    },
    camposAdicionales(){
      if(!this.editedItem.id_gasto_subtipo) return {
        requisitos: [],
        opcionales: []
      };

      var gastoSubtipo = this.gastoSubtipos.find(x => x.id_gasto_subtipo == this.editedItem.id_gasto_subtipo);

      if(!gastoSubtipo) return {
        requisitos: [],
        opcionales: []
      };

      else return {
        requisitos: gastoSubtipo.programacion_pago_orden_requisitos,
        opcionales: gastoSubtipo.programacion_pago_orden_opcionales
      };
    },
    fiscalReglasFiltradas(){
      if(!this.editedItem.monto || this.editedItem.monto <= 0 || !this.editedItem.id_moneda) return this.fiscalReglas;

      return this.fiscalReglas.filter(x => x.monto_maximo >= (this.editedItem.monto * this.getMonedaCambio(this.editedItem.id_moneda)))
    }
  },
  mounted() {
    this.getItems();
    this.getProveedores();
    this.getMonedas();
    this.getProyectos();
    this.getEmpleados();
    this.getGastoSubtipos();
  },
  methods: {
    codigoNombre: item => `[${item.codigo}] - ${item.nombre}`,
    // ==================== API ====================
    getItems() {
      this.loading = true;
      axios
        .get('/Pagos/ListarProgramacionCompraOrdenes', {
          params: {
            programacion_pago_orden_estado: this.search.programacion_pago_orden_estado,
            id_proveedor: this.search.id_proveedor,
            num_programacion_pago_orden: this.search.num_programacion_pago_orden
          }
        })
        .then(response => {
          this.items = response.data || [];
          this.calcularEstadisticas();
        })
        .catch(error => {
          console.log(error);
          //this.$refs.alert.setMessage("Error", "No se pudieron cargar las Ordenes de Programación de Pago");
          //this.$refs.alert.open();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    saveDialogAddEdit() {
      if (!this.validateForm()) return;

      this.loadingSave = true;

      const formData = new FormData();

      formData.append('id_gasto_subtipo', this.editedItem.id_gasto_subtipo);
      formData.append('id_moneda', this.editedItem.id_moneda);
      formData.append('monto', this.editedItem.monto);
      if(this.editedItem.no_serie) formData.append('no_serie', this.editedItem.no_serie);
      if(this.editedItem.marca) formData.append('marca', this.editedItem.marca);
      if(this.editedItem.modelo) formData.append('modelo', this.editedItem.modelo);
      if(this.editedItem.no_inventario_ubga) formData.append('no_inventario_ubga', this.editedItem.no_inventario_ubga);
      if(this.editedItem.id_proyecto) formData.append('id_proyecto', this.editedItem.id_proyecto);
      if(this.editedItem.ids_empleados) formData.append('ids_empleados', this.editedItem.ids_empleados);
      formData.append('id_proveedor', this.editedItem.id_proveedor);
      formData.append('descripcion', this.editedItem.descripcion);
      formData.append('id_fiscal_regla', this.editedItem.id_fiscal_regla);
      formData.append('numero_facturas', this.editedItem.numero_facturas);

      // Siempre mandar facturas cuando existan (1 o más) para que el backend tenga la programación
      if (this.editedItem.facturas && this.editedItem.facturas.length > 0) {
        formData.append('id_intervalo', this.editedItem.id_intervalo);
        formData.append('fecha_inicio', this.editedItem.fecha_inicio);

        this.editedItem.facturas.forEach((f, i) => {
          formData.append(`facturas[${i}].fecha`, f.fecha);
          formData.append(`facturas[${i}].monto`, f.monto);
          formData.append(`facturas[${i}].total_factura`, this.getTotal(f.monto));
          formData.append(`facturas[${i}].total_pagado`, this.getTotalSinRetencion(f.monto));

          // Si necesitas conservar un "numero" explícito (por si hay huecos/orden custom):
          // formData.append(`facturas[${i}].numero`, i + 1);
        });
      }

      if (this.editedItem.archivo_cotizacion instanceof File) {
        formData.append('archivo_cotizacion', this.editedItem.archivo_cotizacion);
      }

      formData.append('usar_iva_frontera', this.editedItem.usar_iva_frontera);
      formData.append('total_factura', this.getTotalGlobal(this.editedItem));
      formData.append('total_pagado', this.getTotalGlobalSinRetencion(this.editedItem));

      axios({
        method: this.editedItem.id_programacion_compra_orden === null ? 'POST' : 'PUT',
        url: this.editedItem.id_programacion_compra_orden === null
          ? '/Pagos/CrearProgramacionCompraOrden'
          : `/Pagos/EditarProgramacionCompraOrden/${this.editedItem.id_programacion_compra_orden}`,
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      })
        .then(() => {
          this.closeDialogAddEdit();
          this.getItems();
          //this.$refs.alert.setMessage("Éxito", "Orden de Programación de Pago guardada correctamente");
          //this.$refs.alert.open();
        })
        .catch(error => {
          console.log(error);
          //this.$refs.alert.setMessage("Error", "Ocurrió un error al guardar la Orden de Programación de Pago");
          //this.$refs.alert.open();
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },

    saveDialogDelete() {
      this.loadingDelete = true;

      axios
        .delete(`/Pagos/EliminarProgramacionCompraOrden/${this.editedItem.id_programacion_compra_orden}`)
        .then(() => {
          this.closeDialogDelete();
          this.getItems();
          //this.$refs.alert.setMessage("Éxito", "Orden de Programación de Pago cancelada correctamente");
          //this.$refs.alert.open();
        })
        .catch(error => {
          console.log(error);
          //this.$refs.alert.setMessage("Error", "Ocurrió un error al cancelar la Orden de Programación de Pago");
          //this.$refs.alert.open();
        })
        .finally(() => {
          this.loadingDelete = false;
        });
    },

    saveDialogAutorizar() {
      this.loadingAutorizar = true;

      axios
        .put(`/Pagos/AutorizarProgramacionCompraOrden/${this.autorizarItem.id_programacion_compra_orden}`)
        .then(() => {
          this.closeDialogAutorizar();
          this.getItems();
          //this.$refs.alert.setMessage("Éxito", "Orden de Programación de Pago autorizada correctamente");
          //this.$refs.alert.open();
        })
        .catch(error => {
          console.log(error);
          //this.$refs.alert.setMessage("Error", "Ocurrió un error al autorizar la Orden de Programación de Pago");
          //this.$refs.alert.open();
        })
        .finally(() => {
          this.loadingAutorizar = false;
        });
    },

    getProveedores() {
      this.loadingProveedores = true;
      axios
        .get('/Proveedores/ListarProveedores', {
          params: {
            id_proveedor_nivel: '267c7302-72fc-4f96-988a-9ea1d2cf6fef',
            estado: 1
          }
        })
        .then(response => {
          this.proveedores = response.data || [];
        })
        .catch(error => {
          console.log(error);
          //this.$refs.alert.setMessage("Error", "No se pudieron cargar los proveedores");
          //this.$refs.alert.open();
        })
        .finally(() => {
          this.loadingProveedores = false;
        });
    },

    getMonedas() {
      this.loadingMonedas = true;
      axios
        .get('/Catalogos/ListarMonedas')
        .then(response => {
          this.monedas = response.data || [];
        })
        .catch(error => {
          console.log(error);
          //this.$refs.alert.setMessage("Error", "No se pudieron cargar las monedas");
          //this.$refs.alert.open();
        })
        .finally(() => {
          this.loadingMonedas = false;
        });
    },

    getProyectos(){
      this.loadingProyectos = true;
      axios
      .get('/Catalogos/ListarProyectos')
      .then(response => {
        this.proyectos = response.data;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingProyectos = false;
      })
    },

    getEmpleados(){
      this.loadingEmpleados = true;
      axios
      .get('/RecursosHumanos/ListarEmpleadosHeaders')
      .then(response => {
        this.empleados = response.data;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingEmpleados = false;
      })
    },

    getGastoSubtipos() {
      this.loadingGastoSubtipos = true;

      axios
        .get('/Pagos/ListarGastoSubTipos')
        .then(response => {
          this.gastoSubtipos = response.data || [];
        })
        .catch(error => {
          console.log(error);
          //this.$refs.alert.setMessage("Error", "No se pudieron cargar los subtipos de gasto");
          //this.$refs.alert.open();
        })
        .finally(() => {
          this.loadingGastoSubtipos = false;
        });
    },

    // ==================== UI ====================
    openDialogAddEdit(editItem = null) {
      if (editItem != null) {
        this.editedItem = Object.assign({}, editItem);
        this.getFiscalReglas(true);
      } else {
        this.editedItem = Object.assign({}, this.defaultEditedItem);
      }

      this.dialogAddEdit = true;
    },

    closeDialogAddEdit() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogAddEdit = false;
    },

    openDialogDelete(editItem) {
      this.editedItem = Object.assign({}, editItem);
      this.dialogDelete = true;
    },

    closeDialogDelete() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogDelete = false;
    },

    openDialogView(viewItem) {
      this.$refs.detalles.open(viewItem);
    },

    openDialogAutorizar(item) {
      this.autorizarItem = Object.assign({}, item);
      this.dialogAutorizar = true;
    },

    closeDialogAutorizar() {
      this.autorizarItem = {
        id_programacion_compra_orden: null,
        numero_orden: null,
        nombre: "",
        monto: 0,
        id_moneda: null,
        moneda_clave: null,
        id_estado: null
      };
      this.dialogAutorizar = false;
    },

    // ==================== CÁLCULOS ====================
    onNumeroFacturasChange() {
      if (this.editedItem.numero_facturas < 1) this.editedItem.numero_facturas = 1;
      if (this.editedItem.numero_facturas > 99) this.editedItem.numero_facturas = 99;

      if (this.editedItem.numero_facturas === 1) {
        this.editedItem.id_intervalo = this.INTERVALOS.BAJO_DEMANDA;
      }

      this.recalcularFacturas();
    },

    recalcularFacturas() {
      if (this.editedItem.numero_facturas > 0) {
        this.recalcularFechas();
        this.distribuirMontos();
      }
    },

    recalcularFechas() {
      if (this.editedItem.numero_facturas <= 0) return;

      const numFacturas = parseInt(this.editedItem.numero_facturas);
      const facturas = [];
      const fechaInicio = new Date(this.editedItem.fecha_inicio + 'T00:00:00');

      for (let i = 0; i < numFacturas; i++) {
        const fecha = this.calcularFechaSiguiente(fechaInicio, i);
        const montoExistente = this.editedItem.facturas[i]?.monto || 0;

        facturas.push({
          fecha: fecha.toISOString().substr(0, 10),
          monto: montoExistente,
          menuFecha: false
        });
      }

      this.editedItem.facturas = facturas;

      if (facturas.every(f => f.monto === 0)) {
        this.distribuirMontos();
      }
    },

    calcularFechaSiguiente(fechaBase, indice) {
      const fecha = new Date(fechaBase);
      const intervalo = this.intervalosFacturacion.find(i => i.id_intervalo === this.editedItem.id_intervalo);

      if (!intervalo) return fecha;

      if (intervalo.dias) {
        fecha.setDate(fecha.getDate() + (indice * intervalo.dias));
      } else if (intervalo.meses) {
        fecha.setMonth(fecha.getMonth() + (indice * intervalo.meses));
      } else if (intervalo.años) {
        fecha.setFullYear(fecha.getFullYear() + (indice * intervalo.años));
      }

      return fecha;
    },

    distribuirMontos() {
      if (this.editedItem.numero_facturas <= 0 || !this.editedItem.monto) return;

      const numFacturas = parseInt(this.editedItem.numero_facturas);
      const montoTotal = parseFloat(this.editedItem.monto);
      const montoPorFactura = Math.floor((montoTotal / numFacturas) * 100) / 100;

      for (let i = 0; i < numFacturas; i++) {
        if (this.editedItem.facturas[i]) {
          this.editedItem.facturas[i].monto = montoPorFactura;
        }
      }

      if (this.editedItem.facturas.length > 0) {
        const sumaActual = this.sumaFacturas;
        const diferencia = montoTotal - sumaActual;
        const ultimaFactura = this.editedItem.facturas[numFacturas - 1];
        ultimaFactura.monto = Math.round((ultimaFactura.monto + diferencia) * 100) / 100;
      }
    },

    validarSumaFacturas() {},

    // ==================== AUX ====================
    formatMoney(value) {
      if (!value) return '0.00';
      return parseFloat(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },

    getEstadoConfig(idEstado) {
      const estado = this.estadosOrden.find(e => e.id_estado === idEstado);
      return estado || { id_estado: 0, nombre: 'Desconocido', color: 'grey', icon: 'mdi-help-circle', tooltip: 'Estado desconocido' };
    },

    getIntervaloNombre(idIntervalo) {
      if (!idIntervalo) return 'N/A';
      const intervalo = this.intervalosFacturacion.find(i => i.id_intervalo === idIntervalo);
      return intervalo ? intervalo.nombre : 'N/A';
    },

    getMonedaClave(idMoneda) {
      if (!idMoneda) return '';
      const moneda = this.monedas.find(m => m.id_moneda === idMoneda);
      return moneda ? moneda.clave : '';
    },

    getMonedaSimbolo(idMoneda) {
      if (!idMoneda) return '';
      const moneda = this.monedas.find(m => m.id_moneda === idMoneda);
      return moneda ? moneda.simbolo : '';
    },

    getMonedaCambio(idMoneda) {
      if (!idMoneda) return 1.0;
      const moneda = this.monedas.find(m => m.id_moneda === idMoneda);
      return moneda ? moneda.tipo_cambio : 1.0;
    },

    getMonedaFechaCambio(idMoneda) {
      if (!idMoneda) return null;
      const moneda = this.monedas.find(m => m.id_moneda === idMoneda);
      return moneda ? moneda.fecha_tipo_cambio : null;
    },

    requiereAutorizacionDireccionGeneral(item) {
      if(this.mostrarVista(15)) return false;
      const moneda = this.monedas.find(m => m.id_moneda === item.id_moneda);
      if (!moneda || !moneda.limite_autorizacion) {
        return true;
      }
      return this.getTotalGlobal(item) > moneda.limite_autorizacion;
    },

    getLimiteAutorizacion(monedaId) {
      const moneda = this.monedas.find(m => m.id_moneda === monedaId);
      return moneda?.limite_autorizacion || 0;
    },

    getFacturasCargadasColor(cargadas, total) {
      if (!cargadas || cargadas === 0) return 'grey';
      const porcentaje = (cargadas / total) * 100;
      if (porcentaje < 50) return 'orange';
      if (porcentaje < 100) return 'blue';
      return 'success';
    },

    getFacturasAutorizadasColor(autorizadas, total) {
      if (!autorizadas || autorizadas === 0) return 'grey';
      const porcentaje = (autorizadas / total) * 100;
      if (porcentaje < 50) return 'warning';
      if (porcentaje < 100) return 'info';
      return 'green';
    },

    getFacturasPagadasColor(pagadas, autorizadas) {
      if (!autorizadas || autorizadas === 0) return 'grey';
      if (!pagadas || pagadas === 0) return 'error';
      const porcentaje = (pagadas / autorizadas) * 100;
      if (porcentaje < 50) return 'deep-orange';
      if (porcentaje < 100) return 'amber';
      return 'teal';
    },

    validateForm() {
      if (!this.editedItem.id_gasto_subtipo) {
        this.$refs.alert.setMessage("", `Debes indicar el Tipo de gasto.`);
        this.$refs.alert.open();
        return false;
      }

      if (!this.editedItem.id_moneda) {
        this.$refs.alert.setMessage("", `Debes seleccionar la moneda.`);
        this.$refs.alert.open();
        return false;
      }

      if (!this.editedItem.monto || this.editedItem.monto <= 0) {
        this.$refs.alert.setMessage("", `El monto total debe ser mayor a 0.`);
        this.$refs.alert.open();
        return false;
      }

      if (
        this.mostrarCampo(1) &&
        this.esRequerido(1) &&
        (!this.editedItem.no_serie || this.editedItem.no_serie.trim().length === 0)
      ) {
        this.$refs.alert.setMessage("", `El No. de serie es obligatorio.`);
        this.$refs.alert.open();
        return false;
      }

      if (
        this.mostrarCampo(2) &&
        this.esRequerido(2) &&
        (!this.editedItem.marca || this.editedItem.marca.trim().length === 0)
      ) {
        this.$refs.alert.setMessage("", `La marca es obligatoria.`);
        this.$refs.alert.open();
        return false;
      }

      if (
        this.mostrarCampo(3) &&
        this.esRequerido(3) &&
        (!this.editedItem.modelo || this.editedItem.modelo.trim().length === 0)
      ) {
        this.$refs.alert.setMessage("", `El modelo es obligatorio.`);
        this.$refs.alert.open();
        return false;
      }

      if (
        this.mostrarCampo(4) &&
        this.esRequerido(4) &&
        (!this.editedItem.no_inventario_ubga || this.editedItem.no_inventario_ubga.trim().length === 0)
      ) {
        this.$refs.alert.setMessage("", `El No. de inventario UBGA es obligatorio.`);
        this.$refs.alert.open();
        return false;
      }

      if (this.mostrarCampo(5) && this.esRequerido(5) && this.editedItem.id_proyecto == null) {
        this.$refs.alert.setMessage("", `Debes seleccionar el proyecto.`);
        this.$refs.alert.open();
        return false;
      }

      if (
        this.mostrarCampo(6) &&
        this.esRequerido(6) &&
        (this.editedItem.ids_empleados == null || this.editedItem.ids_empleados.length <= 0)
      ) {
        this.$refs.alert.setMessage("", `Debes seleccionar al menos un empleado.`);
        this.$refs.alert.open();
        return false;
      }

      if (!this.editedItem.id_proveedor) {
        this.$refs.alert.setMessage("", `Debes seleccionar el proveedor.`);
        this.$refs.alert.open();
        return false;
      }

      // OJO: aquí corregí el mensaje (antes decía "El proveedor es requerido")
      // y corregí la validación para usar length.
      if (!this.editedItem.descripcion || this.editedItem.descripcion.trim().length < 10) {
        this.$refs.alert.setMessage("", `La descripción es obligatoria y debe tener al menos 10 caracteres.`);
        this.$refs.alert.open();
        return false;
      }

      if (!this.editedItem.archivo_cotizacion) {
        this.$refs.alert.setMessage("", `Debes adjuntar la cotización o presupuesto.`);
        this.$refs.alert.open();
        return false;
      }

      if (!this.editedItem.id_fiscal_regla) {
        this.$refs.alert.setMessage("", `Debes seleccionar una Regla fiscal.`);
        this.$refs.alert.open();
        return false;
      }

      if (!this.editedItem.numero_facturas || this.editedItem.numero_facturas < 1 || this.editedItem.numero_facturas > 99) {
        this.$refs.alert.setMessage("", `El número de facturas debe estar entre 1 y 99.`);
        this.$refs.alert.open();
        return false;
      }

      if (this.editedItem.numero_facturas > 1) {
        if (!this.editedItem.id_intervalo) {
          this.$refs.alert.setMessage("", `Debes seleccionar el intervalo cuando hay más de una factura.`);
          this.$refs.alert.open();
          return false;
        }

        if (!this.editedItem.fecha_inicio) {
          this.$refs.alert.setMessage("", `Debes indicar la fecha de inicio cuando hay más de una factura.`);
          this.$refs.alert.open();
          return false;
        }

        const diferencia = Math.abs(this.sumaFacturas - this.editedItem.monto);
        if (diferencia > 0.01) {
          this.$refs.alert.setMessage(
            "",
            `La suma de las facturas ($${this.formatMoney(this.sumaFacturas)}) debe coincidir con el monto total ($${this.formatMoney(this.editedItem.monto)}).`
          );
          this.$refs.alert.open();
          return false;
        }
      }

      return true;
    },

    pct(value) {
      return `${(value * 100).toFixed(1)}%`;
    },

    nf(value) {
      return value.toLocaleString('es-MX');
    },

    calcularEstadisticas() {
      const total = this.items.length;

      if (total === 0) {
        this.stats = {
          total: 0,
          pendiente_num: 0, pendiente_per: 0,
          autorizada_num: 0, autorizada_per: 0,
          facturada_parcial_num: 0, facturada_parcial_per: 0,
          facturada_total_num: 0, facturada_total_per: 0,
          cancelada_num: 0, cancelada_per: 0,
        };
        return;
      }

      this.stats.pendiente_num = this.items.filter(item => item.id_estado === this.ESTADOS.PENDIENTE_AUTORIZACION).length;
      this.stats.autorizada_num = this.items.filter(item => item.id_estado === this.ESTADOS.AUTORIZADA).length;
      this.stats.facturada_parcial_num = this.items.filter(item => item.id_estado === this.ESTADOS.FACTURADA_PARCIAL).length;
      this.stats.facturada_total_num = this.items.filter(item => item.id_estado === this.ESTADOS.FACTURADA_TOTAL).length;
      this.stats.cancelada_num = this.items.filter(item => item.id_estado === this.ESTADOS.CANCELADA).length;

      this.stats.pendiente_per = this.stats.pendiente_num / total;
      this.stats.autorizada_per = this.stats.autorizada_num / total;
      this.stats.facturada_parcial_per = this.stats.facturada_parcial_num / total;
      this.stats.facturada_total_per = this.stats.facturada_total_num / total;
      this.stats.cancelada_per = this.stats.cancelada_num / total;

      this.stats.total = total;
    },

    mostrarCampo(value){
      return this.esRequerido(value) || this.esOpcional(value)
    },

    esRequerido(value){
      return this.camposAdicionales.requisitos.some(x => x == value);
    },

    esOpcional(value){
      return this.camposAdicionales.opcionales.some(x => x == value);
    },

    shouldRetryAxios(error) {
      // 1) HTTP status >= 500
      const status = error?.response?.status;
      if (typeof status === "number" && status >= 500) return true;

      // 2) Timeout (axios usa code ECONNABORTED muchas veces)
      const code = (error?.code || "").toString();
      const msg = (error?.message || "").toString().toLowerCase();
      if (code === "ECONNABORTED" || msg.includes("timeout")) return true;

      // 3) Network error (no hay response)
      // En axios, cuando no hay respuesta del server suele venir error.response undefined
      if (!error?.response) {
        // a veces viene "Network Error"
        if (msg.includes("network error")) return true;

        // o fallas de red / DNS / conexión (varía por entorno)
        if (
          msg.includes("failed to fetch") ||
          msg.includes("network") ||
          msg.includes("connection") ||
          msg.includes("dns")
        ) return true;
      }

      return false;
    },

    async sleep(ms) {
      return new Promise((r) => setTimeout(r, ms));
    },

    async getFiscalReglas(edited = false) {
      if(!this.editedItem.id_gasto_subtipo || !this.editedItem.id_proveedor) return;
      this.loadingFiscalReglas = true;

      const maxRetries = 3;
      const baseDelayMs = 400;

      try {
        for (let attempt = 1; attempt <= maxRetries; attempt++) {
          try {
            const response = await axios.get(`/Pagos/ObtenerReglasFiscales/${this.editedItem.id_gasto_subtipo}/${this.editedItem.id_proveedor}?programacion_pago_orden=true`, {
              timeout: 10000
            });

            this.fiscalReglas = response.data || [];
            if(!edited) this.editedItem.id_fiscal_regla = null;
            return;
          } catch (error) {
            const canRetry = this.shouldRetryAxios(error);

            console.log(
              `getFiscalReglas fallo (intento ${attempt}/${maxRetries})`,
              { canRetry, status: error?.response?.status, code: error?.code, message: error?.message }
            );

            // si no es reintentable o ya se acabaron intentos -> re-lanza
            if (!canRetry || attempt === maxRetries) throw error;

            // backoff exponencial
            await this.sleep(baseDelayMs * Math.pow(2, attempt - 1));
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingFiscalReglas = false;
      }
    },

    setIdReglaFiscal(){
      this.editedItem.id_fiscal_regla = null;
    },

    getIva(monto){
      if(!this.editedItem.id_fiscal_regla || !this.fiscalReglas) return null;
      const fiscalRegla = this.fiscalReglas.find(m => m.id_fiscal_regla === this.editedItem.id_fiscal_regla);
      if(!fiscalRegla) return null;
      return monto * (((this.editedItem.usar_iva_frontera ? 0.5 : 1.0) * fiscalRegla.iva) / 100.0);
    },

    getIsr(monto){
      if(!this.editedItem.id_fiscal_regla  || !this.fiscalReglas) return null;
      const fiscalRegla = this.fiscalReglas.find(m => m.id_fiscal_regla === this.editedItem.id_fiscal_regla);
      if(!fiscalRegla) return null;
      return monto * (fiscalRegla.isr / 100.0);
    },

    getIvaRetencion(monto){
      if(!this.editedItem.id_fiscal_regla  || !this.fiscalReglas) return null;
      const fiscalRegla = this.fiscalReglas.find(m => m.id_fiscal_regla === this.editedItem.id_fiscal_regla);
      if(!fiscalRegla) return null;
      return monto * (((this.editedItem.usar_iva_frontera ? 0.5 : 1.0) * fiscalRegla.iva_retencion) / 100.0);
    },

    getTotal(monto){
      return (monto) + (this.getIva(monto) || 0.0) - (this.getIsr(monto) || 0.0) - (this.getIvaRetencion(monto) || 0.0);
    },

    getTotalSinRetencion(monto){
      return (monto) + (this.getIva(monto) || 0.0);
    },

    getTotalGlobal(item){
      if(!item.id_fiscal_regla || !this.fiscalReglas) return null;
      const fiscalRegla = this.fiscalReglas.find(m => m.id_fiscal_regla === item.id_fiscal_regla);
      if(!fiscalRegla) return null;
      return (item.monto) + (item.monto * (((item.usar_iva_frontera ? 0.5 : 1.0) * fiscalRegla.iva) / 100.0)) - (item.monto * ((fiscalRegla.isr || 0) / 100)) - (item.monto * (((item.usar_iva_frontera ? 0.5 : 1.0) * fiscalRegla.iva_retencion) / 100.0));
    },
    getTotalGlobalSinRetencion(item){
      if(!item.id_fiscal_regla  || !this.fiscalReglas) return null;
      const fiscalRegla = this.fiscalReglas.find(m => m.id_fiscal_regla === item.id_fiscal_regla);
      if(!fiscalRegla) return null;
      return (item.monto) + (item.monto * (((item.usar_iva_frontera ? 0.5 : 1.0) * fiscalRegla.iva) / 100.0));
    },
    mostrarVista(id_vista){
			if(this.ids_vistas == null || this.ids_vistas.length == 0) return false;
			return (this.ids_vistas.indexOf(id_vista) >= 0);
		},
  }
}
</script>

<style scoped>
.v-data-table >>> .v-data-table__wrapper {
  overflow-x: auto;
}

.kpi-line {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.kpi-figure {
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1;
}

.kpi-pill {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.85rem;
  line-height: 1.2;
  border: 1px solid transparent;
}

/* Variantes de color (ajústalas a tu paleta Vuetify si quieres) */
/* Variantes de color (ajústalas a tu paleta Vuetify si quieres) */
.kpi-pill--success {
  background: #e8f5e9;   /* green lighten-5 */
  color: #2e7d32;        /* green darken-3 */
  border-color: #c8e6c9; /* green lighten-4 */
}

.kpi-pill--info {
  background: #e3f2fd;   /* blue lighten-5 */
  color: #1565c0;        /* blue darken-3 */
  border-color: #bbdefb; /* blue lighten-4 */
}

.kpi-pill--warning {
  background: #fff8e1;   /* amber lighten-5 */
  color: #ef6c00;        /* orange darken-3 */
  border-color: #ffe0b2; /* orange lighten-4 */
}

.kpi-pill--primary {
  background: #e3f2fd;   /* si quieres más “primary”, puedes cambiar a un azul más cercano a tu theme */
  color: #1976d2;        /* Vuetify primary (aprox) */
  border-color: #bbdefb;
}

.kpi-pill--error {
  background: #ffebee;   /* red lighten-5 */
  color: #c62828;        /* red darken-3 */
  border-color: #ffcdd2; /* red lighten-4 */
}
</style>
